<header class="onboarding-header">
  <div class="container-fluid">
    <div class="head">
      <div class="row">
        <div class="col-md-12">
        </div>
      </div>
      <div class="content-filters">
        <div class="row onboarding">
          <div class="col-sm-9">
            <ul class="status">
              <li><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount1}}</span></div><em> Position Requests Submitted</em><span></span></li>
              <li class="first"><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount2}}</span></div><em> Registrations Submitted</em><span></span></li>
              <li class="second"><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount3}}</span></div><em> Registrations Approved</em><span></span></li>
              <li class="currentone"><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount4}}</span></div><em> Onboardings In Progress</em><span></span></li>
              <li (click)="requestStatusSearch(7)" style="cursor:pointer" class="cencelled"><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount7}}</span></div><em> Registrations Cancelled</em><span></span></li>
              <li (click)="requestStatusSearch(6)" style="cursor:pointer" class="third"><div class="hdr-count" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount5}}</span></div><em> Requests Completed <br />in the last 30 days</em></li>
            </ul>
          </div>
          <div class="col-md-2">
            <ul class="reject"><li><div class="hdr-count rej" style="margin-left:45%"><span style="display: block; font-size: 1.3em;">{{itemCount6}}</span></div><em> Registrations Rejected  <br /><i class="fa fa-thumbs-o-down fa-2x"></i> </em></li></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>


<div class="hr-dashboard">
  <div class="onboarding-filter-div">
    <div class="row d-flex">
      <div class="col-10 p-0">
        <div class="form-group onboarding">
          <span>
            <nbc-select name="positionStatus"
                        [source]="requestStatus"
                        value="id"
                        display="description"
                        [(model)]="selectedRequestStatus"
                        placeHolderDisplay="Request Status"
                        placeHolderValue="0"
                        (change)="changeRequestStatus()">
            </nbc-select>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group onboarding col-md-6">
        <span class="ps-0" style="max-width:200px;float:left;padding-right:10px;">
          <nbc-select name="searchCriteriaSelection"
                      [(model)]="selectSearchCriteria"
                      [source]="searchCriteria"
                      placeHolderDisplay="Select a Search Criteria"
                      placeHolderValue="0"
                      display="optionDescription"
                      value="optionValue"
                      (change)="changeSearchCriteria()">
          </nbc-select>&nbsp;
        </span>
        <span class="d-flex">
          <input class="form-control w-25 input-sm" *ngIf="selectSearchCriteria?.optionValue == '1'"
                 name="contactSearchCriteria"
                 [disabled]="searchTextboxEnable"
                 placeholder="Enter the Name"
                 [(ngModel)]="contactSearchTerm"
                 [typeahead]="contactObservable$"
                 [typeaheadAsync]="true"
                 typeaheadOptionField="fullName"
                 [typeaheadOptionsLimit]="25"
                 (typeaheadLoading)="changeTypeaheadLoading($event)"
                 [typeaheadWaitMs]="500"
                 (typeaheadOnSelect)="onContactSearchTermSelect($event)"
                 [isAnimated]="true" />

          <input class=" form-control w-25  input-sm"
                 name="textSearchCriteria"
                 [disabled]="searchTextboxEnable || selectSearchCriteria?.optionValue=='0'"
                 placeholder="Enter the Search Term"
                 [(ngModel)]="queryContainer.query.searchTerm.description"
                 [isAnimated]="true"
                 *ngIf="!selectSearchCriteria || selectSearchCriteria?.optionValue=='0'" />

          <button class="onboarding-go-button"
                  [disabled]="goButtonEnable"
                  (click)="queryContainer.query.currentPage=1; search()">
            Go
          </button>

          <button class="onboarding-reset-button"
                  (click)="restartSearch()">
            Reset
          </button>
        </span>
      </div>
    </div>

  </div>
  <div class="page-content pad-10">
    <p *ngIf="gridData.items.length === 0">No Results</p>
    <div *ngIf="gridData.items.length > 0">
      <div class="row view-options">
        <div class="col-md-4">
          <div class="form-inline form-sort-options">
            <div class="form-group">
              <nbc-page-size [source]="pageSizeList" [model]="queryContainer.query.pageSize" (nbcValueChange)="searchPage($event)"></nbc-page-size>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group text-end d-flex float-end">
            <label class="pagination-results">
              <pagination-label pageSize="{{queryContainer.query.pageSize}}"
                                currentPage="{{queryContainer.query.currentPage}}"
                                totalRecords="{{queryContainer.query.totalRecords}}"></pagination-label>
            </label>
            <nbc-pagination totalItems="{{queryContainer.query.totalRecords}}"
                            itemsPerPage="{{queryContainer.query.pageSize}}"
                            [(currentPage)]="queryContainer.query.currentPage"
                            (pageChanged)="search();"></nbc-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content pad-10">
    <onboarding-historygrid></onboarding-historygrid>
  </div>
</div>
